export const GET_NOTIFICATIONS_EVENTS = 'GET_NOTIFICATIONS_EVENTS';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const SET_NOTIFICATIONS_EVENTS = 'SET_NOTIFICATIONS_EVENTS';
export const SET_NOTIFICATIONS_EVENT = 'SET_NOTIFICATIONS_EVENT';
